module.exports = __webpack_public_path__ + "front/img/d14.a638a84d.png";